






















































































import { Component, Prop, Vue } from 'vue-property-decorator';

import ColumnTitleContent from '@/components/UI/Table/ColumnTitleContent.vue';

import MmStatusBadge from '../../components/MmStatusBadge.vue';
import MmTable from '../../components/MmTable.vue';
import { MM_EMPTY_DASH, formatDateTime } from '../../core/format';
import { MmTask } from '../../types/domain';
import { MmMonitoringBatch } from './batch';

const RESULTS_KEY = 'priceMonitoring.mobileMonitoring.results.';
const TASKS_KEY = 'priceMonitoring.mobileMonitoring.tasks.';

const COLUMN_WIDTHS = {
	competitor: 220,
	address: 260,
	type: 150,
	status: 130,
	auditor: 180,
	positions: 120,
	createdAt: 150,
	completedAt: 150,
	actions: 100,
};

@Component({
	components: { ColumnTitleContent, MmStatusBadge, MmTable },
})
export default class BatchTasksTable extends Vue {
	@Prop({ default: null }) readonly batch!: MmMonitoringBatch | null;

	get rows(): MmTask[] {
		return this.batch === null ? [] : this.batch.tasks;
	}

	get hasTasks(): boolean {
		return this.rows.length > 0;
	}

	get titleText(): string {
		return this.$t(RESULTS_KEY + 'tasksTableTitle', { count: this.rows.length }) as string;
	}

	get emptyText(): string {
		return this.$t(TASKS_KEY + 'emptyTitle') as string;
	}

	get openTaskHintText(): string {
		return this.$t(RESULTS_KEY + 'openTaskHint') as string;
	}

	/** Колонки только слотами, с key и без dataIndex: вложенный dataIndex уехал бы в сортировку */
	get columns(): any[] {
		return [
			this.buildColumn('competitorCode', TASKS_KEY + 'colCompetitor', COLUMN_WIDTHS.competitor, 'competitorCell', 'left'),
			this.buildColumn('address', TASKS_KEY + 'colAddress', COLUMN_WIDTHS.address, 'addressCell'),
			this.buildColumn('type', TASKS_KEY + 'colType', COLUMN_WIDTHS.type, 'typeCell'),
			this.buildColumn('status', TASKS_KEY + 'colStatus', COLUMN_WIDTHS.status, 'statusCell'),
			this.buildColumn('auditorLogin', TASKS_KEY + 'colAuditor', COLUMN_WIDTHS.auditor, 'auditorCell'),
			this.buildColumn('positions', RESULTS_KEY + 'colPositions', COLUMN_WIDTHS.positions, 'positionsCell'),
			this.buildColumn('createdAt', TASKS_KEY + 'colCreatedAt', COLUMN_WIDTHS.createdAt, 'createdAtCell'),
			this.buildColumn('completedAt', RESULTS_KEY + 'colCompletedAt', COLUMN_WIDTHS.completedAt, 'completedAtCell'),
			{
				key: 'actions',
				title: this.$t('shared.labels.actions'),
				scopedSlots: { customRender: 'actions' },
				fixed: 'right',
				width: COLUMN_WIDTHS.actions,
			},
		];
	}

	get titledColumns(): any[] {
		const source = this.columns;
		const result: any[] = [];

		for (let i = 0; i < source.length; i += 1) {
			if (source[i].slots && source[i].slots.title && source[i].slotColumnTitleData) {
				result.push(source[i]);
			}
		}

		return result;
	}

	/** Без scroll.x закрепление колонок в ant не работает */
	get scrollX(): number {
		return (
			COLUMN_WIDTHS.competitor +
			COLUMN_WIDTHS.address +
			COLUMN_WIDTHS.type +
			COLUMN_WIDTHS.status +
			COLUMN_WIDTHS.auditor +
			COLUMN_WIDTHS.positions +
			COLUMN_WIDTHS.createdAt +
			COLUMN_WIDTHS.completedAt +
			COLUMN_WIDTHS.actions
		);
	}

	get rowClassName(): (record: MmTask, index: number) => string {
		return function buildRowClass(record: MmTask): string {
			return 'sm-mobilemon__row--clickable';
		};
	}

	get customRow(): (record: MmTask, index: number) => any {
		const self = this;

		return function buildRow(record: MmTask): any {
			return {
				on: {
					click: function onRowClick(event: any): void {
						self.handleRowClick(record, event);
					},
				},
			};
		};
	}

	competitorCodeOf(task: MmTask): string {
		return this.dashed(task.competitorCode);
	}

	storeTextOf(task: MmTask, field: string): string {
		const store = task.competitorStore as any;

		if (store === null || store === undefined) {
			return MM_EMPTY_DASH;
		}

		return this.dashed(store[field]);
	}

	positionsTextOf(task: MmTask): string {
		const withPrice = task.positionsWithPrice;
		const total = task.positionsTotal;

		if (!this.isNumber(withPrice) && !this.isNumber(total)) {
			return MM_EMPTY_DASH;
		}

		const left = this.isNumber(withPrice) ? String(withPrice) : MM_EMPTY_DASH;
		const right = this.isNumber(total) ? String(total) : MM_EMPTY_DASH;

		return left + ' / ' + right;
	}

	dateTimeText(value: string | null | undefined): string {
		return formatDateTime(value);
	}

	dashed(value: string | null | undefined): string {
		return value !== null && value !== undefined && String(value).trim() !== ''
			? String(value)
			: MM_EMPTY_DASH;
	}

	/** Выделение текста не должно открывать карточку: mouseup приходит на строку */
	handleRowClick(record: MmTask, event: any): void {
		if (record === null || record === undefined || !record.id) {
			return;
		}

		const selection = window.getSelection ? window.getSelection() : null;

		if (selection && String(selection.toString()).trim() !== '') {
			return;
		}

		if (this.isInteractiveTarget(event)) {
			return;
		}

		this.handleOpenTask(record);
	}

	handleOpenTask(task: MmTask): void {
		if (task === null || task === undefined || !task.id) {
			return;
		}

		this.$emit('open-task', String(task.id));
	}

	private isNumber(value: number | null | undefined): boolean {
		return typeof value === 'number' && !isNaN(value);
	}

	private isInteractiveTarget(event: any): boolean {
		const target: any = event && event.target ? event.target : null;

		if (!target || typeof target.closest !== 'function') {
			return false;
		}

		return target.closest('a, button, input, textarea, select, .ant-select, .ant-checkbox-wrapper') !== null;
	}

	/** Заголовок только слотом: MmTable подставляет слот, лишь когда title не задан */
	private buildColumn(key: string, titleKey: string, width: number, slotName: string, fixed?: string): any {
		const column: any = {
			key: key,
			slots: { title: key + 'BatchColumnTitle' },
			slotColumnTitleData: {
				text: this.$t(titleKey) as string,
			},
			width: width,
			scopedSlots: { customRender: slotName },
		};

		/** Ключ fixed кладём только по факту: ant считает свойство заданным даже со значением undefined */
		if (fixed !== undefined) {
			column.fixed = fixed;
		}

		return column;
	}
}
